module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.critical.length) ? _c('div', {
    staticClass: "nt-banner-wrap"
  }, [_vm._l((_vm.shown), function(n) {
    return _c('div', {
      key: n.id,
      staticClass: "nt-banner",
      attrs: {
        "role": "alert"
      }
    }, [_c('i', {
      staticClass: "fa nt-banner-icon",
      class: n.severity === 'critical' ? 'fa-exclamation-circle' : 'fa-exclamation-triangle nt-banner-icon-warning',
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "nt-banner-text"
    }, [_c('strong', [_vm._v(_vm._s(n.title))]), _vm._v(" "), (n.body) ? _c('span', [_vm._v(_vm._s(n.body))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "nt-banner-actions"
    }, [(n.link) ? _c('button', {
      staticClass: "nt-banner-btn nt-banner-btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openItem(n)
        }
      }
    }, [_vm._v("Open")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "nt-banner-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.dismiss(n)
        }
      }
    }, [_vm._v("Dismiss")])])])
  }), _vm._v(" "), (_vm.critical.length > _vm.shown.length) ? _c('router-link', {
    staticClass: "nt-banner-more",
    attrs: {
      "to": "/notifications"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.critical.length - _vm.shown.length) + " more need attention\n  ")]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6286c996","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationBanner.vue
// module id = 321+
// module chunks = 1